module.exports = __webpack_public_path__ + "static/media/CircularPro-BookItalic.05f4b04a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/CircularPro-BookItalic.svg
// module id = 117
// module chunks = 0